{
  "nav": {
    "home": "Home",
    "about": "About Intermedia",
    "services": "Services",
    "clients": "Clients",
    "projects": "Projects",
    "partnerships": "Partnerships",
    "partnership_entrepreneur": "Business Partnership",
    "partnership_programmer": "Programming Partnership",
    "work_training": "Work & Training",
    "free_positions": "Open Positions",
    "training_program": "Training & Mentoring Program",
    "self_learning": "Self-Learning Resources",
    "contact": "Contact"
  },
  "breadcrumbs": {
    "home": "Home",
    "work_training": "Work & Training",
    "training_program": "Training & Mentoring Program",
    "self_learning": "Self-Learning Resources",
    "free_positions": "Open Positions",
    "partnerships": "Partnerships",
    "partnership_entrepreneur": "Business Partnership",
    "partnership_programmer": "Programming Partnership",
    "contact": "Contact",
    "services": "Services",
    "clients": "Clients",
    "projects": "Projects",
    "refunds": "Refunds Policy",
    "delivery": "Delivery Policy"
  },
  "home": {
    "title": "About Intermedia",
    "intro_text": "We develop comprehensive web solutions (websites, web applications and mobile applications) for {companyYear} years. Our office and team are located in Ruse, Bulgaria.",
    "partnership_entrepreneur_title": "I have capital and an idea, looking for a team",
    "partnership_programmer_title": "I'm working on my own project, looking for financing",
    "services_intro": "We offer the following services:",
    "service_project_management": "Project management using Agile methodology (Scrum and Kanban)",
    "service_development": "Application development (design, creation of website, web application and mobile application development)",
    "more_about": "More about Intermedia",
    "we_work_with": "We work with:",
    "tech_stack": "Laravel · Symfony · Ionic · ReactJS · AI Coding · AWS · Linode",
    "team_title": "Team",
    "partnerships_title": "Partnerships",
    "partnerships_intro": "We invest in good ideas. We work on a joint venture basis both with entrepreneurs looking for a development team for their idea, and with programmers who do not have the necessary resources to commercialize their products.",
    "partnerships_choose": "If you want to discuss a joint venture, choose the link that best describes your situation:",
    "entrepreneur_button_line1": "I have capital and an idea,",
    "entrepreneur_button_line2": "looking for a team",
    "programmer_button_line1": "I have a project,",
    "programmer_button_line2": "looking for financing",
    "programmer_button_long": "I'm working on my own project, looking for financing",
    "our_projects": "Our Projects",
    "more_projects": "More about our projects",
    "work_training_title": "Work & Training",
    "training_intro": "We train and provide mentoring to beginner web developers. Our development program covers the following topics:",
    "training_programming_basics": "Programming fundamentals and algorithms",
    "training_oop": "Object-oriented programming",
    "training_clean_code": "Writing clean code",
    "training_php_laravel": "PHP and Laravel",
    "training_databases": "Databases",
    "training_tools": "Professional development tools",
    "more_training": "More about work and training at Intermedia",
    "free_positions_title": "Open Positions",
    "position_laravel": "PHP Developer: Laravel",
    "position_symfony": "PHP Developer: Symfony"
  },
  "team": {
    "member_0_first": "Krasimir",
    "member_0_full": "Krasimir Hristozov",
    "member_1_first": "Nikolay",
    "member_1_full": "Nikolay Datsov",
    "member_2_first": "Plamen",
    "member_2_full": "Plamen Valchinovski",
    "member_3_first": "Angel",
    "member_3_full": "Angel Draganov",
    "member_4_first": "Dimitar",
    "member_4_full": "Dimitar Rekinov",
    "member_5_first": "Milen",
    "member_5_full": "Milen Genov",
    "member_6_first": "Simona",
    "member_6_full": "Simona Ilcheva",
    "member_7_first": "Ivo",
    "member_7_full": "Ivo Vladimirov",
    "member_8_first": "Salih",
    "member_8_full": "Salih Rejeb",
    "member_9_first": "Viktor",
    "member_9_full": "Viktor Velikov"
  },
  "services": {
    "title": "Services",
    "business_analysis": "Business Analysis",
    "ba_intro": "Every new project at Intermedia begins with requirements analysis and conducting a series of conversations with the client to answer the following questions:",
    "ba_question_1": "What are the client's requirements and what are their actual needs?",
    "ba_question_2": "How does the business currently work and what problems does the project solve?",
    "ba_question_3": "What is the business value of the project?",
    "ba_question_4": "Can the project be avoided entirely, with problems solved using the client's existing systems or ready-made systems from external providers?",
    "ba_conclusion": "After preparing a clear assessment of the value that the project will bring, we proceed to design the minimum possible version of the product that will benefit the client, and we start development using Agile methodology.",
    "project_management": "Project Management",
    "pm_philosophy": "Our philosophy for project management consists of three core principles:",
    "pm_principle_1_title": "Partners, not executors",
    "pm_principle_1_text": "We don't work according to client-sent requirements and specifications, but strive to fully understand the client's business in order to offer a pragmatic solution to every problem.",
    "pm_principle_2_title": "Always create value",
    "pm_principle_2_text": "Every next version of the product, as well as every change or new functionality, must bring obvious and measurable value to the client.",
    "pm_principle_3_title": "Transparency in relationships",
    "pm_principle_3_text": "We give the client access to our project management system and maintain constant communication, so we can always answer the following questions:",
    "pm_principle_3_question_1": "What tasks are being worked on now?",
    "pm_principle_3_question_2": "Who is working on each task and what is the execution deadline?",
    "pm_principle_3_question_3": "What is the planned and actual time used for each task?",
    "pm_conclusion": "We use Agile methodology (Scrum or Kanban, depending on project needs) and Lean Startup principles - short iterations until releasing new versions (we work with weekly sprints), rapid validation of changes, and immediate start of the next iteration.",
    "development": "Application Development",
    "dev_intro": "At Intermedia, we don't just make websites and don't engage in digital marketing (we've left that task to experts in that field). We create web applications and mobile applications that solve real business problems and bring value to our clients, using best practices in modern software development.",
    "dev_agile": "Using Agile methodology allows us to quickly adapt to changes in requirements and create solutions that can be tested and deployed in minimal timeframes, then updated and maintained.",
    "dev_cloud": "We offer not only software development, but also building and maintaining cloud server architecture (we mainly work with AWS and Linode)."
  },
  "clients": {
    "title": "Clients",
    "oncallcentral_description": "SaaS product to facilitate communication between patients and medical practices in the USA. Offers the ability to dynamically create phone menus, as well as support for different departments and schedules for phone menus. Maintains an on-call schedule with automatic notifications to on-call doctors according to a pre-created scheme. Records all conducted conversations, the complete history of each call and related notifications. The product has been developed and maintained by us since its creation.",
    "pps_description": "For PPS we created a series of desktop products for managing a property portfolio, with multiple awards for best product in the industry. These products are the foundation of our Landlord Vision project.",
    "taxinsider_description": "Tax Insider is an extremely popular monthly publication designed for entrepreneurs, investors and freelancers in the United Kingdom. The publication offers useful practical advice for reducing taxation and optimizing income and expenses.",
    "globelaw_description": "Globe Law and Business is a publisher of specialized literature on tax and business topics in the United Kingdom. For them we developed a content management system and e-commerce website.",
    "rentgen_description": "For Rentgen Ruse at Dukovi Clinic we developed a web-based application for managing patient images with the ability to quickly share necessary information between patients, X-ray and treating dentists."
  },
  "projects": {
    "title": "Our Projects",
    "lv_intro": "SaaS product for managing a property portfolio for the UK market. Includes all necessary tools to enable owners of rental properties to manage their business:",
    "lv_feature_1": "Complete, integrated accounting system;",
    "lv_feature_2": "Portfolio and property management;",
    "lv_feature_3": "Tenant management module, including a maintenance support system (based on our Aikidesk product);",
    "lv_feature_4": "Financial module;",
    "lv_feature_5": "Supplier management module;",
    "lv_feature_6": "Generation of a complete set of documents according to legislative requirements;",
    "lv_feature_7": "Integrated calendar with event notifications and early warnings;",
    "lv_feature_8": "Reports, including accounting reports compliant with tax legislation;",
    "lv_feature_9": "Ability to automatically collect rent through integration with GoCardless;",
    "lv_feature_10": "Mobile applications for Android and iOS.",
    "landlord_vision_title": "Landlord Vision",
    "landlord_vision_description": "The system is used by over 4000 users managing more than 20000 active rental agreements. It is the only system recommended by the UK's largest landlord association - NRLA.",
    "aikidesk_title": "Aikidesk",
    "aikidesk_intro": "Web-based customer service system. This is the commercial version of our product for our own use, which is successfully used in companies such as Superhosting (with tens of thousands of clients). The main advantages of our system are:",
    "aikidesk_feature_1": "Complete localization for the Bulgarian market;",
    "aikidesk_feature_2": "Automatic processing of requests and email responses, automatic creation of mailboxes for departments;",
    "aikidesk_feature_3": "Editable email templates;",
    "aikidesk_feature_4": "Event history for each request;",
    "aikidesk_feature_5": "Internal messages and dynamic notifications during work, to avoid simultaneous work by two operators on the same request, or missing a message from the user while writing a response."
  },
  "job": {
    "free_positions_title": "Open Positions",
    "application_form_title": "Application Form",
    "position": "Position",
    "position_laravel_full": "PHP Programmer - Laravel",
    "position_symfony_full": "PHP Programmer - Symfony",
    "position_2_requirements": "- Excellent knowledge of programming fundamentals - algorithm development and analysis<br>- Excellent knowledge of object-oriented programming<br>- Experience in relational database design<br>- PHP/MySQL<br>- Experience with MVC-based PHP Framework (we mainly use Laravel, we offer training opportunity)<br>- English proficiency (written - working level)<br>- Git",
    "position_2_advantages": "- Knowledge of HTML5 and CSS3<br>- Experience with JavaScript framework (Vue.js, React.js or Angular)<br>- Experience with AI coding tools (Claude Code, GitHub Copilot)",
    "position_2_qualities": "- Excellent communication skills<br>- Good organization and self-discipline<br>- Desire to improve skills and professional growth",
    "position_2_note": "Work is only on-site at the company office. We offer the opportunity for training and work on interesting SaaS projects. The position is suitable for students.",
    "position_1_requirements": "- Excellent knowledge of programming fundamentals - algorithm development and analysis<br>- Excellent knowledge of object-oriented programming<br>- PHP, experience with Symfony framework (we offer training opportunity)<br>- PostgreSQL<br>- English proficiency (written - working level)<br>- Git",
    "position_1_advantages": "- Experience with AI coding tools (Claude Code, GitHub Copilot)",
    "position_1_qualities": "- Excellent communication skills<br>- Good organization and self-discipline<br>- Desire to improve skills and professional growth",
    "position_1_note": "Work is only on-site at the company office. The position is suitable for students.",
    "requirements_title": "Requirements:",
    "advantages_title": "Advantages:",
    "qualities_title": "We value the following personal qualities:",
    "direction": "Direction",
    "name": "Name",
    "name_placeholder": "First and Last Name",
    "email": "Email",
    "phone": "Phone",
    "why_apply": "Why are you applying with us",
    "expectations": "What do you expect from this program",
    "cv_formats": "CV allowed formats: pdf, ods",
    "submit_cv": "Submit CV",
    "send": "Send"
  },
  "training": {
    "intro": "Our training and mentoring program is completely free and is intended primarily (but not only) for students in the field of information technology and computer science. The program begins with an assessment of the initial level (through conducting an interview) and creating an individual program for self-learning and working on your own project, with the goal of acquiring the necessary knowledge to start working as a web developer. We provide feedback and code review, as well as additional guidance during self-learning. We rely mainly on the personal motivation of each candidate and accept only a small portion of candidates in our program.",
    "areas_intro": "The program covers the following areas of professional competence:",
    "general": "General:",
    "topic_programming_basics": "Programming fundamentals;",
    "topic_algorithms": "Algorithms and data structures;",
    "topic_algorithm_analysis": "Algorithm analysis;",
    "topic_oop": "Object-oriented programming and design (SOLID/DRY principles, design patterns);",
    "topic_clean_code": "Writing clean code;",
    "topic_testing": "Code testing, TDD/BDD;",
    "topic_refactoring": "Refactoring, working with existing code;",
    "topic_functional": "Functional programming;",
    "topic_tools": "Tools (git, WSL2, docker);",
    "topic_ai_coding_tools": "AI coding tools (Claude Code, GitHub Copilot, prompt engineering);",
    "topic_agile": "Agile methodology (Scrum, Kanban) and collaboration tools (Zoho Projects, Trello, Asana, Slack);",
    "topic_estimation": "Development time estimation techniques;",
    "topic_communication": "Professional communication;",
    "topic_cv_presentation": "CV preparation and presentation skills for presenting personal projects.",
    "backend": "For backend developers:",
    "topic_databases": "Databases (SQL);",
    "topic_devops": "DevOps (Linux administration - Ubuntu/CentOS/Amazon Linux, cloud service providers - AWS, Linode, DigitalOcean, shell programming)",
    "topic_php": "PHP;",
    "topic_laravel": "Laravel;",
    "topic_dev_environments": "Development environments;",
    "topic_other_language": "Another programming language of the candidate's choice - Python, Ruby (+Rails).",
    "frontend": "For frontend developers:",
    "topic_javascript": "JavaScript, ECMAScript, TypeScript;",
    "topic_html_css": "HTML/CSS/Bootstrap/Flexbox;",
    "topic_vuejs": "React/Angular;",
    "topic_state_management": "Vuex/Redux;",
    "topic_frontend_tools": "Tools (npm, yarn, webpack);"
  },
  "contact": {
    "title": "Contact Us",
    "name": "Name",
    "name_placeholder": "First and Last Name",
    "email": "Email",
    "message": "Message",
    "send": "Send",
    "contact_info": "Contact Information",
    "phone": "Phone",
    "address": "Address",
    "company_name": "Intermedia Ltd",
    "company_street": "4 Nikolay Zdravkov St",
    "company_city": "Ruse 7012",
    "map_email": "Email",
    "map_phone": "Phone",
    "map_address": "Address"
  },
  "partnership": {
    "name": "Name",
    "name_placeholder": "First and Last Name",
    "email": "Email",
    "phone": "Phone",
    "project_description": "Project Description",
    "attach_files": "Attach Materials",
    "allowed_formats": "allowed formats: pdf, ods, zip",
    "development_platform": "Development Platform",
    "git_link": "GitHub/BitBucket Link",
    "send": "Send"
  },
  "resources": {
    "title": "Self-Learning Resources",
    "filter": "Filter",
    "results": "Found {count} results",
    "tags": "Tags",
    "no_results": "No results found"
  },
  "footer": {
    "copyright": "© {year} Intermedia. All rights reserved.",
    "refunds_policy": "Refunds Policy",
    "delivery_policy": "Delivery Policy"
  },
  "messages": {
    "invalid_email": "Invalid email address",
    "invalid_git_link": "Invalid GitHub/BitBucket link",
    "required": "The :attribute field is required",
    "recaptcha": "\"I'm not a robot\" is required",
    "success": "Successfully sent",
    "error": "An error occurred",
    "loading": "Loading...",
    "contact_us_sent": "Message sent successfully",
    "job_app_sent": "Application sent successfully"
  },
  "validation": {
    "email": "The :attribute field is in invalid format",
    "min": "The :attribute field must be a string with minimum length of :min characters",
    "max": "The :attribute field must be a string with maximum length of :max characters",
    "string": "The :attribute field must be a string",
    "required": "The :attribute field is required",
    "file": "Invalid file",
    "file_name": "Invalid file: :name"
  },
  "common": {
    "menu_title": "Menu",
    "select_option": "- Select -",
    "choose_file": "Choose file",
    "read_more": "Read more",
    "back": "Back",
    "next": "Next",
    "close": "Close",
    "submit": "Submit",
    "cancel": "Cancel",
    "save": "Save",
    "delete": "Delete",
    "edit": "Edit",
    "search": "Search",
    "filter": "Filter",
    "all": "All",
    "yes": "Yes",
    "no": "No"
  }
}
